module.exports = __webpack_public_path__ + "media/images/products-img-06-47b8ece58d782a66d9cc9b6c1a4f38fb.png";